module.exports = __webpack_public_path__ + "static/media/Tornado.6b2d6e30.jpg";